<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
<h1 mat-dialog-title class="mat-dialog-container__title">
  {{ 'NGX-MESSAGING.edit_phone_number' | translate | uppercase }}
</h1>
<div mat-dialog-content>
  <form [formGroup]="phoneForm">
    <ngx-material-intl-tel-input
      [iconMakeCall]="false"
      [autoSelectCountry]="false"
      [enableSearch]="true"
      [required]="true"
      [fieldControl]="phoneControl"
      [autoIpLookup]="false"
      [preferredCountries]="['us']">
    </ngx-material-intl-tel-input>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button class="chat-input__button" color="primary" (click)="save()" [disabled]="!phoneForm.valid">
    {{ 'NGX-MESSAGING.save' | translate }}
  </button>
</div>
